export { CompanyQRsTable as default } from './CompanyQRsTable'
